import { render, staticRenderFns } from "./editradio.vue?vue&type=template&id=a3f67ce4&"
import script from "./editradio.vue?vue&type=script&lang=js&"
export * from "./editradio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports